import { render, staticRenderFns } from "./MarkTheExam.vue?vue&type=template&id=db5dd1ce&scoped=true"
import script from "./MarkTheExam.vue?vue&type=script&lang=js"
export * from "./MarkTheExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5dd1ce",
  null
  
)

export default component.exports